module.exports = __webpack_public_path__ + "static/media/messageblack.60d6ae0b.svg";